import { type ThunkAction } from "redux-thunk";
import { type RootState } from "~/redux/store";
import { type AnyAction } from "~/redux/types";
import { trackSendToSalesPartnerButton } from "~/feature/Analytics/ga/ga";

export function trackShareWishlistThunk(
  salesPartnerName: string,
  wishlistId: string,
): ThunkAction<void, RootState, undefined, AnyAction> {
  return (dispatch, getState) => {
    const { wishlistPage: wlState, products } = getState();
    const entries =
      wlState.wishlists[wishlistId]?.entryIds
        .map((id) => wlState.entries[id])
        .filter(Boolean)
        .map((entry) => ({
          designation: products.basic[entry.productCode].designation,
          quantity: entry.quantity,
        })) ?? [];

    trackSendToSalesPartnerButton(salesPartnerName, entries, wishlistId);
  };
}
